import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  CreateInvestigationPayload,
  InvestigationDetail,
  InvestigationListItem,
  InvestigationsResponse,
  UpdateInvestigationPayload,
} from '../../shared/models/investigation.models';

export interface InvestigationFilterParams {
  pageSize?: number;
  pageIndex?: number;
  filter?: string;
  programId?: string;
  categoryId?: string;
  dateFrom?: string;
  dateTo?: string;
  /** 'Open' or 'Closed' (closed = finding and finding date set). */
  status?: string;
}

@Injectable({ providedIn: 'root' })
export class InvestigationService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/api`;

  getInvestigations(params: InvestigationFilterParams = {}) {
    let httpParams = new HttpParams()
      .set('pageSize', params.pageSize ?? 100)
      .set('pageIndex', params.pageIndex ?? 0)
      .set('filter', params.filter ?? '');
    if (params.programId) httpParams = httpParams.set('programId', params.programId);
    if (params.categoryId) httpParams = httpParams.set('categoryId', params.categoryId);
    if (params.dateFrom) httpParams = httpParams.set('dateFrom', params.dateFrom);
    if (params.dateTo) httpParams = httpParams.set('dateTo', params.dateTo);
    if (params.status) httpParams = httpParams.set('status', params.status);
    return this.http.get<InvestigationsResponse>(`${this.base}/investigations`, {
      params: httpParams,
    });
  }

  getInvestigationById(id: string) {
    return this.http.get<InvestigationDetail>(`${this.base}/investigations/${id}`);
  }

  createInvestigation(payload: CreateInvestigationPayload) {
    return this.http.post<InvestigationListItem>(`${this.base}/investigations`, payload);
  }

  updateInvestigation(payload: UpdateInvestigationPayload) {
    return this.http.put<InvestigationDetail>(`${this.base}/investigations`, payload);
  }

  /** Clears the finding of a closed investigation. System Administration only (403 otherwise). */
  reopenInvestigation(id: string) {
    return this.http.put<InvestigationDetail>(`${this.base}/investigations/${id}/reopen`, {});
  }

  deleteInvestigation(id: string) {
    return this.http.delete<void>(`${this.base}/investigations/${id}`);
  }
}
